var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLoading48Line = function SvgIconLoading48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38.79c-3.79 0-7.58-1.44-10.46-4.33-2.8-2.79-4.33-6.51-4.33-10.46 0-3.95 1.54-7.67 4.33-10.46A14.742 14.742 0 0 1 28.15 9.8l-1.01 3.46c-1.18-.34-2.37-.5-3.55-.45-2.83.1-5.5 1.27-7.51 3.27A11.119 11.119 0 0 0 12.8 24c0 2.99 1.17 5.8 3.28 7.92 4.37 4.37 11.47 4.37 15.84 0 2.89-2.89 3.98-7.13 2.83-11.07l3.46-1.01c1.52 5.2.08 10.8-3.74 14.62-2.88 2.89-6.67 4.33-10.46 4.33H24Z",
    fill: "current"
  })));
};
export default SvgIconLoading48Line;